import styled from 'styled-components';
import * as R from 'ramda';
import Input from '~~elements/Input';
import Button from '~~elements/Button';
import Select from '~~elements/Select';
import toast from '~~elements/Toast';

export const UpdateDiv = styled.div`
  display: block;
  margin: 7px 0;
  .origin {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 1.5rem;
  }
  input {
    width: auto;
  }
  button.update-btn {
    width: 150px;
  }
`;

export const StyledTableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  max-height: 70vh;
  font-size: 0.8rem;
  table {
    border: 0px;
  }

  th,
  td {
    text-align: center;
    white-space: nowrap;
    padding: 6px 10px;
  }

  thead th {
    top: 0;
    position: sticky;
    z-index: 20;
    background-color: #a1d6f7;
    &.first {
      z-index: 50;
    }
  }

  .first {
    width: 50px;
    left: 0px;
    position: sticky;
    background-color: #a1d6f7;
    cursor: pointer;
  }

  tr {
    border-bottom: 1px solid lightgray;
    &.selected {
      background-color: #83f2a1;
    }
    &:not(.selected) {
      td[class=' disabled'] {
        background: #eaeaea;
      }
    }
  }
  td {
    &.inEdit {
      background-color: #fcb9b3;
    }
  }
`;

export const getValue = (row, rowIndex, column) => {
  if (column.match(/^fielders\.\d$/)) {
    const position = column.split('.')[1];
    const fielder = R.find((f) => `${f.position}` === `${position}`, row.fielders);
    if (!fielder) {
      return '-';
    }
    return fielder.fielder.name;
  }

  const value = column.split('.').reduce((pre, cur) => (R.is(Object, pre) ? pre[cur] : pre), row);
  if (R.is(Boolean, value)) {
    return value ? 'O' : 'X';
  } else if (R.is(Array, value)) {
    return value.join(', ');
  }
  return value;
};

export const getUpdateDiv = (
  rows,
  columns,
  setSelectedRow,
  setSelectColumn,
  selectedRow,
  selectColumn,
  handleUpdate,
  extra = {},
) => {
  const row = rows[selectedRow];
  if (!row || !selectColumn) {
    return <></>;
  }

  const id = `input-${selectedRow}-${selectColumn}`.split('.')[0];
  const firstColumn = R.find((c) => c.className === 'first', columns);
  const targetColumn = R.find((c) => c.column === selectColumn, columns);

  const tryUpdate = (directUpdate) => {
    let inputEl = document.querySelector(`#${id}`);
    console.log(inputEl);
    if (!inputEl) {
      return;
    }

    let newValue = inputEl.value;
    switch (targetColumn.updatable) {
      case Number:
        newValue = parseInt(newValue);
        if (Number.isNaN(newValue) || newValue < 0) {
          toast('更新格式錯誤', { status: 'error' });
          return;
        }
        break;
      case Boolean:
        newValue = inputEl.checked;
        break;
      case 'Batter': {
        const newBatter = R.find((p) => p.name === newValue, extra.batters);
        newValue = R.clone(newBatter);
        break;
      }
      case 'Pitcher': {
        const newPitcher = R.find((p) => p.name === newValue, extra.pitchers);
        newValue = R.clone(newPitcher);
        break;
      }
      case 'Catcher': {
        const newCatcher = R.find((p) => p.name === newValue, extra.catchers);
        newValue = R.clone(newCatcher);
        break;
      }
      case 'Fielders': {
        const newFielders = R.find((p) => p.name === newValue, extra.fielders);
        newValue = R.clone(newFielders);
        break;
      }
      default:
        break;
    }
    console.log(newValue);

    // 所有更新都以第一層為基礎
    let toUpdateColumn = targetColumn.column.split('.')[0];
    if (['pitcher', 'batter', 'catcher'].includes(toUpdateColumn)) {
      toUpdateColumn = `new_${toUpdateColumn}`;
    } else if ('fielders' === toUpdateColumn) {
      toUpdateColumn = `new_${toUpdateColumn}_${targetColumn.column.split('.')[1]}`;
    }

    if (!directUpdate) {
      extra.handleRowSave(selectedRow, toUpdateColumn, newValue);
      return;
    }

    const cloneRow = R.clone(rows[selectedRow]);
    cloneRow[toUpdateColumn] = newValue;
    handleUpdate(selectedRow, cloneRow);
  };

  let inputComponent = <Input key={id} id={id} defaultValue={row[targetColumn.column]} />;
  switch (targetColumn.updatable) {
    case Boolean:
      inputComponent = (
        <label>
          Boolean
          <input type="checkbox" key={id} id={id} defaultChecked={row[targetColumn.column]} />
          &nbsp;
        </label>
      );
      break;
    case 'Handed':
      inputComponent = (
        <Select key={id} id={id} defaultValue={row[targetColumn.column]}>
          <option value="R">R</option>
          <option value="L">L</option>
        </Select>
      );
      break;
    case 'Batter':
      inputComponent = (
        <Select key={id} id={id} defaultValue={getValue(row, selectedRow, targetColumn.column)}>
          {extra.batters.map((p) => (
            <option key={p.uniqid} value={p.name}>{`#${p.number} ${p.name}`}</option>
          ))}
        </Select>
      );
      break;
    case 'Pitcher':
      inputComponent = (
        <Select key={id} id={id} defaultValue={getValue(row, selectedRow, targetColumn.column)}>
          {extra.pitchers.map((p) => (
            <option key={p.uniqid} value={p.name}>{`#${p.number} ${p.name}`}</option>
          ))}
        </Select>
      );
      break;
    case 'Catcher':
      inputComponent = (
        <Select key={id} id={id} defaultValue={getValue(row, selectedRow, targetColumn.column)}>
          {extra.catchers.map((p) => (
            <option key={p.uniqid} value={p.name}>{`#${p.number} ${p.name}`}</option>
          ))}
        </Select>
      );
      break;
    case 'Fielders':
      inputComponent = (
        <Select key={id} id={id} defaultValue={getValue(row, selectedRow, targetColumn.column)}>
          {extra.fielders.map((p) => (
            <option key={p.uniqid} value={p.name}>{`#${p.number} ${p.name}`}</option>
          ))}
        </Select>
      );
      break;
    default:
      break;
  }

  return (
    <UpdateDiv key={id}>
      <div className="origin">
        <span>{`${firstColumn.label}：${getValue(row, selectedRow, firstColumn.column)}`}</span>
        <span>{`${targetColumn.label}：${getValue(row, selectedRow, targetColumn.column)}（編輯中）`}</span>
      </div>
      {inputComponent}
      <Button
        color="transparent"
        width="80px"
        onClick={() => {
          setSelectedRow(-1);
          setSelectColumn('');
        }}
      >
        取消
      </Button>
      {handleUpdate && (
        <Button color="red" width="80px" onClick={() => tryUpdate(true)}>
          更新
        </Button>
      )}
      {extra.handleRowSave && (
        <Button color="blue" width="80px" onClick={() => tryUpdate(false)}>
          暫存
        </Button>
      )}
    </UpdateDiv>
  );
};

export const tableRender = (
  rows,
  columns,
  setSelectedRow,
  setSelectColumn,
  selectedRow,
  selectColumn,
  statsUpdateRows = [],
) => (
  <table>
    <thead>
      <tr>
        {columns.map((column) => (
          <th key={column.column} className={column.className}>
            {column.label}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {rows.map((row, rowIndex) => (
        <tr key={rowIndex} className={selectedRow === rowIndex ? 'selected' : ''}>
          {columns.map((column) => (
            <td
              key={column.column}
              className={`${column.className ?? ''}${
                selectedRow === rowIndex && selectColumn === column.column ? ' inEdit' : ''
              }${column.updatable ? '' : ' disabled'}`}
              {...(column.className === 'first'
                ? {
                    onClick: () => {
                      setSelectedRow((pre) => (pre === rowIndex ? -1 : rowIndex));
                      setSelectColumn('');
                    },
                  }
                : column.updatable
                ? {
                    onDoubleClick: () => {
                      if (selectedRow === rowIndex && selectColumn === column.column) {
                        setSelectedRow(-1);
                        setSelectColumn('');
                        return;
                      }
                      setSelectedRow(rowIndex);
                      setSelectColumn(column.column);
                    },
                  }
                : {})}
              style={statsUpdateRows[rowIndex] ? { backgroundColor: 'orange' } : {}}
            >
              {getValue(row, rowIndex, column.column)}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);
